import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import {
  FDDialogActions, FDDialogContent, FDPrimaryActionButton, FDPrimaryActionIconButton, FDStack,
} from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import fr from 'facet-rest';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import { RichTextAlertDescription } from 'Views/Page/Content/Modal/Layouts/JobBasicInformationStep/Layout/RichTextAlertDescription';
import { FormSection } from 'Components/ComponentLibrary/Molecules/FormSection';
import { dataAttrs } from 'Helpers/Testing';

const Layout = () => {
  const { resource, onSubmit, saving } = useMetaLayoutContext();
  const { loadModalCollectionByLink } = useModalContext();

  const handleContinue = async () => {
    await onSubmit();
  };

  return (
    <>
      <MetaControlField attr="title" />
      <FDDialogContent>
        <FDStack direction="column" spacing={3}>
          <FDStack direction="column" spacing={1}>
            <MetaControlField attr="basicsDescription" />
            <MetaControlField attr="clientId" flex={1} />
            <FDStack direction="row" spacing={2} wrap>
              <MetaControlField attr="employer" flex={1} />
              <MetaControlField attr="jobTitle" flex={1} />
            </FDStack>
          </FDStack>
          <FDStack direction="column" spacing={1}>
            <MetaControlField attr="payDetailsTitle" />
            <MetaControlField attr="payDetailsDescription" />
            <FDStack direction="row" spacing={2} wrap>
              <MetaControlField attr="frequencyGrossValue" flex={1} />
              <MetaControlField attr="frequency" flex={1} />
            </FDStack>
          </FDStack>
          <MetaControlField
            attr="grossIncomeDescription"
            flex={1}
            CustomProps={{
              Component: RichTextAlertDescription,
            }}
          />
          <FormSection title={'Advanced Options'}>
            <MetaControlField attr={'startType'} />
            <MetaControlField attr={'startAtAge'} />
            <MetaControlField attr={'startDate'} />
            <MetaControlField attr={'endType'} />
            <MetaControlField attr={'endAtAge'} />
            <MetaControlField attr={'endDate'} />
          </FormSection>
        </FDStack>
      </FDDialogContent>
      <FDDialogActions>
        {resource.withRelationship(fr.relationships.previousLink.name,
          (rel) => (
            <FDPrimaryActionIconButton
              icon="chevronLeft"
              onClick={() => {
                loadModalCollectionByLink(rel.link('related').url());
              }}
            />
          ),
          () => null)}
        {resource.meta().canPost() ? <FDPrimaryActionButton {...dataAttrs('continue-btn', resource)} loading={saving} label={'Continue'} onClick={handleContinue} /> : null}
      </FDDialogActions>
    </>
  );
};

export default Layout;
